module.exports = __webpack_public_path__ + "static/media/module_quiz.d847c733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/modules/module_quiz.jpg
// module id = ./src/resources/images/modules/module_quiz.jpg
// module chunks = 0